import { z } from 'zod';
import { insightsGroupRowSchema } from './common';

export const POSTS_INSIGHTS_GROUP_BY = ['none', 'client', 'status', 'type', 'approver'] as const;
export const postsInsightsGroupBySchema = z.enum(POSTS_INSIGHTS_GROUP_BY);
export type PostsInsightsGroupBy = z.infer<typeof postsInsightsGroupBySchema>;

export const POSTS_INSIGHTS_DATE_FIELDS = [
  'createdAt',
  'date',
  'scheduledAt',
  'approvedAt',
  'publishedAt',
] as const;
export const postsInsightsDateFieldSchema = z.enum(POSTS_INSIGHTS_DATE_FIELDS);
export type PostsInsightsDateField = z.infer<typeof postsInsightsDateFieldSchema>;

export const postsInsightsResponseSchema = z.object({
  total: insightsGroupRowSchema,
  groups: z.array(insightsGroupRowSchema),
  groupBy: postsInsightsGroupBySchema,
});

export type PostsInsightsResponse = z.infer<typeof postsInsightsResponseSchema>;
